import { makeStyles } from '@material-ui/core';

import { colors } from '@chhjit/react-components';

export const useStyles = makeStyles(() => ({
  dialogPaper: {
    width: '100%',
    maxWidth: '500px',
  },
  avatarIconButton: {
    padding: '0px',
  },
  avatar: {
    height: '100px',
    width: '100px',
  },
  avatarApproved: {
    color: colors.functionals.alert,
  },
  inputAvatar: {
    display: 'none',
  },
  addAvatarBadge: {
    display: 'flex',
    padding: '6px',
    borderRadius: '100px',
    position: 'relative',
    top: '-10px',
    right: '15px',
    backgroundColor: colors.primary.main,
    '& svg': {
      fontSize: '12px',
    },
    '& path': {
      fill: colors.white,
    },
  },
}));
